import { Vue } from 'vue-property-decorator';

import userService from '@/services/user.service';
import errorsService from '@/services/errors.service';
import accountService from '@/services/account.service';

import { ITokenModel } from '@/models/token.model';
import { ISteamCallbackResultModel, ISteamUnlinkModel, ISteamUnlinkResultModel } from '@/models/steam.model';

export default {
  goToSteam(context: Vue, redirectUrl?: string): void {
    context.$store.dispatch("updateIsLinkingSteamLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    let url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "steam/auth?callbackPath=/steam/callback";
    if (redirectUrl != null) {
      url += "&redirectUrl=" + redirectUrl;
    }

    accountService.get<string>(context, url)
      .then(response => {
        context.$store.dispatch("updateIsLinkingSteamLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        window.location.href = response;
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingSteamLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        errorsService.handleErrors(context, error);
      });
  },

  callbackSteam(context: Vue, token: ITokenModel): void {
    context.$store.dispatch("updateIsLinkingCallbackLoading", true);
    context.$store.dispatch("updateIsLinkingSteamLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "steam/callback";

    accountService.post<object, ISteamCallbackResultModel>(context, url, {}, { params: context.$route.query, headers: { Authorization: "Bearer " + token.Value } })
      .then(async response => {
        const steamId = response.AccountId;
        let redirectUrl = context.$store.getters.redirectUrl;

        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingSteamLoading", false);

        if (redirectUrl != null) {
          redirectUrl += ((redirectUrl.includes("?") ? "&" : "?") + "steamid=" + steamId);
          window.location.href = redirectUrl;
          context.$store.dispatch("updateIsLoading", false);
          return;
        }

        userService.updateUser(context, redirectUrl != null, true);
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingSteamLoading", false);
        context.$store.dispatch("updateIsLoading", false);

        errorsService.handleErrors(context, error);
      });   
  },

  callbackSteamPartner(context: Vue, token: ITokenModel, state: string): void {
    context.$store.dispatch("updateIsLinkingCallbackLoading", true);
    context.$store.dispatch("updateIsLinkingLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "steam/partner/callback";

    accountService.post<object, ISteamCallbackResultModel>(context, url, { "State": state }, { headers: { Authorization: "Bearer " + token.Value } })
      .then(async response => {
        const steamId = response.AccountId;
        let redirectUrl = response.RedirectUrl != null ? response.RedirectUrl : context.$store.getters.redirectUrl;

        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingSteamLoading", false);
        context.$store.dispatch("updateIsLinkingLoading", false);

        if (redirectUrl != null) {
          redirectUrl += ((redirectUrl.includes("?") ? "&" : "?") + "steamid=" + steamId);
          window.location.href = redirectUrl;
          context.$store.dispatch("updateIsLoading", false);
          return;
        }

        userService.updateUser(context, redirectUrl != null, true);
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingSteamLoading", false);
        context.$store.dispatch("updateIsLinkingLoading", false);
        context.$store.dispatch("updateIsLoading", false);

        errorsService.handleErrors(context, error);
      });
  },

  unlinkSteam(context: Vue, token: ITokenModel, steamId: string) {
    context.$store.dispatch("updateIsLinkingSteamLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "steam/unlink";

    accountService.post<ISteamUnlinkModel, ISteamUnlinkResultModel>(context, url, { SteamId: steamId }, { headers: { Authorization: "Bearer " + token.Value } })
      .then(() => {
        context.$store.dispatch("updateIsLinkingSteamLoading", false);
        context.$store.dispatch("updateIsLoading", false);

        const redirectUrl = context.$store.getters.redirectUrl;

        if (redirectUrl != null) {
          window.location.href = redirectUrl;
          return;
        }

        userService.updateUser(context, redirectUrl != null, true);
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingSteamLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        errorsService.handleErrors(context, error);
      });
  }
}
